import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { AmenityStatus } from "@b2bportal/lodging-api";
import { AmenityIcon, HotelShopSection, useAmenities } from "@tenant/hotels";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Amenities.module.scss";

export interface AmenitiesComponentProps extends PlatformComponentProps {
  amenities: AmenityStatus[];
}

const COMPONENT_KEY = CoreHotelsComponent.Amenities;

export const Amenities = (props: AmenitiesComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, text } = useAmenities(props);

  return (
    <HotelShopSection className={clsx(block, className)} title={text.title}>
      <ul className={cn("amenity-list")}>
        {context.amenitiesToShow.map(({ amenity, displayName }) => (
          <li key={amenity} className={cn("amenity-item")}>
            <AmenityIcon
              className={cn("amenity-icon")}
              amenity={amenity}
              alt={displayName}
            />
            {displayName}
          </li>
        ))}
      </ul>
      <Dialog>
        <DialogTrigger className={cn("more-amenities")}>
          {text.moreAmenities}
        </DialogTrigger>
        <DialogContent title={text.title}>
          <ul className={cn("dialog-amenity-list")}>
            {context.amenities.map(({ amenity, displayName }) => (
              <li key={amenity} className={cn("amenity-item")}>
                <AmenityIcon
                  className={cn("amenity-icon")}
                  amenity={amenity}
                  alt={displayName}
                />
                {displayName}
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
      {children}
    </HotelShopSection>
  );
};
